export default "__VITE_ASSET__C9slgyTc__"